<template>
    <div style="display: flex;">
        <!-- <span>123123</span>
        <span>{{ qrcodeDataURL }}</span>
        <img :src="qrcodeDataURL" alt="二维码" /> -->

        <img :src="qrcodeDataURL" alt="二维码" width="90" height="90" />

        <!-- <vue-qrcode :value="qrContent" :options="qrOptions" :color="color" :type="type" /> -->

    </div>
</template>

<script>

import QRCode from 'qrcode'
export default {
    data() {
        return {
            qrContent: '',
            qrcodeDataURL: '',
            // color: {
            //     dark: '#34495e',   // 深色模块
            //     light: '#ffffff'   // 浅色背景
            // },
            // type: 'imges',

            // qrOptions: {

            //     margin: 1,           // 边距
            //     width: 200,          // 宽度
            //     color: {
            //         dark: '#34495e',   // 深色模块
            //         light: '#ffffff'   // 浅色背景
            //     },
            //     ecLevel: 'H'
            // }

        }
    },
    // components: { VueQrcode },
    props: {
        data: {
            type: Object
        }
    },
    mounted() {
        this.qrContent = this.data.val;

        const text = 'Hello, Vue3!'
        const width = 200
        const height = 200
        const correctLevel = 'M'

        // 创建一个TextEncoder实例
        const encoder = new TextEncoder();

        // 将字符串转换为UTF-8编码的Uint8Array
        const uint8array = encoder.encode(this.data.val);
        console.log(uint8array);

        QRCode.toDataURL(
            this.data.val, {
            color: {
                dark: "#000",
                light: "#fff"
            },
            width: 80,
            height: 80,
            margin: 5
        }
        )
            .then((url) => {
                // 获取到url后即可在页面使用--二维码图片
                console.log('url', url)
                this.qrcodeDataURL = url;
            })
            .catch((e) => {
                console.log('e', e)
            });


    },
    methods: {

    }
}
</script>

<style></style>